import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class SmsService extends Service {
	constructor(injector: Injector) {
		super("Sms", injector);
	}
}